 
import { routes } from "../../../../routers/routes";
import Breadcrumbs from "../../../commonComponents/breadcrumbs";
import Testimonials from "../../../home/common/Testimonials";
import PrimeCar from "./PrimeCar";
import CarService from "./CarService";

const AboutUs2Container = () => {
  return (
    <>
      <Breadcrumbs title="About" url={routes.Home.CarDemo1} mainClass="page-breadcrumbs-section" />
      <PrimeCar />
      <CarService />
      <Testimonials type={"car_demo1"} animation={false} />
    </>
  );
};

export default AboutUs2Container;
